module.exports = __webpack_public_path__ + "img/Sugar3.e5e80b77.jpg";